import { AxiosInstance } from 'axios';
import { Api, ApiConfig, HttpClient } from '../codegen/SwaggerProduct';
interface SwaggerProductReservationApi {
    httpClient: HttpClient<any> | null;
    api: Api<any> | null;
}

interface SwaggerProductReservationApiConfiguration<SecurityDataType = unknown> {
    config?: ApiConfig<SecurityDataType>;
    modifyInstance?: (instance: AxiosInstance) => void;
}

// For global acces throughout the application
const singleton: SwaggerProductReservationApi = {
    httpClient: null,
    api: null,
};

export const configureSwaggerProductReservationApi = ({
    config = {},
    modifyInstance,
}: SwaggerProductReservationApiConfiguration) => {
    const httpClient = new HttpClient(config);
    if (modifyInstance) modifyInstance(httpClient.instance);

    const api = new Api(httpClient);

    singleton.httpClient = httpClient;
    singleton.api = api;
};

// Helpers for accesing globally the client
// Only these can be used to access the client
export const getSwaggerProductReservationApi = () => {
    if (!singleton.httpClient) throw new Error('[httpClient] Not Initialized');
    if (!singleton.api) throw new Error('[api] Not Initialized');

    return singleton as SwaggerProductReservationApi;
};

export const getProductReservationApi = () => {
    if (!singleton.api) throw new Error('[api] Not Initialized');

    return singleton.api as Api<any>;
};

export const getProductReservationHttpClient = () => {
    if (!singleton.httpClient) throw new Error('[httpClient] Not Initialized');

    return singleton.httpClient as HttpClient<any>;
};
